import React, { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { Box, FormControl, TextField } from '@material-ui/core';

import { ApiFilterCriteria } from '../../types';
import FilterPopover from './FilterPopover';

interface TextFilterProps {
  field: string;
  name: string;
  onChange: (value: string) => void;
  criteria: ApiFilterCriteria;
}

const TextFilter = (props: TextFilterProps) => {
  const { criteria } = props;
  const [value, setValue] = useState<string>('');
  const [currentCriteria, setCurrentCriteria] =
    useState<ApiFilterCriteria | null>(null);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = event.target;

    setValue(newValue);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const { value: newValue } = event.target;

    setValue(newValue);
    props.onChange(newValue);
  };

  /**
   * Handle initial load.
   */
  useEffect(() => {
    // If the criteria did not change, don't run update.
    if (
      criteria !== null &&
      JSON.stringify(criteria) === JSON.stringify(currentCriteria)
    ) {
      return;
    }

    const filterValue = criteria.filters ? criteria.filters[props.field] : '';
    if (filterValue && typeof filterValue === 'string') {
      setValue(filterValue);
    } else {
      setValue('');
    }

    setCurrentCriteria(criteria);
  }, [criteria]);

  const hasFilters = useMemo(() => {
    return value.length >= 1;
  }, [value]);

  return (
    <FilterPopover name={props.name} hasFilters={hasFilters}>
      <Box pl={2} pr={2}>
        <FormControl margin="normal">
          <TextField
            type="text"
            label={props.name}
            onChange={handleChange}
            onBlur={handleBlur}
            value={value}
          />
        </FormControl>
      </Box>
    </FilterPopover>
  );
};

export default TextFilter;
